import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmojiBlueSmileEyeOpen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_5302_91261)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M24 48C37.2546 48 48 37.2546 48 24C48 10.7454 37.2546 0 24 0C10.7454 0 0 10.7454 0 24C0 37.2546 10.7454 48 24 48Z",
				fill: "#1DBADF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.2669 19.8895C14.2669 22.5275 12.1289 24.6686 9.48776 24.6686C6.84666 24.6686 4.70862 22.5306 4.70862 19.8895C4.70862 17.2484 6.84972 15.1104 9.48776 15.1104C12.1258 15.1104 14.2669 17.2515 14.2669 19.8895Z",
				fill: "#1C1C1C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.34973 18.0397C9.34973 18.8157 8.7209 19.4446 7.94482 19.4446C7.16875 19.4446 6.53992 18.8157 6.53992 18.0397C6.53992 17.2636 7.16875 16.6348 7.94482 16.6348C8.7209 16.6348 9.34973 17.2636 9.34973 18.0397Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.8895 20.2546C10.8895 20.7025 10.5276 21.0645 10.0797 21.0645C9.63186 21.0645 9.2699 20.7025 9.2699 20.2546C9.2699 19.8068 9.63186 19.4448 10.0797 19.4448C10.5276 19.4448 10.8895 19.8068 10.8895 20.2546Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M43.2883 19.8895C43.2883 22.5275 41.1472 24.6686 38.5091 24.6686C35.8711 24.6686 33.73 22.5306 33.73 19.8895C33.73 17.2484 35.8711 15.1104 38.5091 15.1104C41.1472 15.1104 43.2883 17.2515 43.2883 19.8895Z",
				fill: "#1C1C1C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M38.3682 18.0397C38.3682 18.8157 37.7393 19.4446 36.9633 19.4446C36.1872 19.4446 35.5583 18.8157 35.5583 18.0397C35.5583 17.2636 36.1872 16.6348 36.9633 16.6348C37.7393 16.6348 38.3682 17.2636 38.3682 18.0397Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M39.908 20.2546C39.908 20.7025 39.546 21.0645 39.0981 21.0645C38.6503 21.0645 38.2883 20.7025 38.2883 20.2546C38.2883 19.8068 38.6503 19.4448 39.0981 19.4448C39.546 19.4448 39.908 19.8068 39.908 20.2546Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29.6197 27.2885C28.8314 29.6842 26.5952 31.3314 24.0799 31.3958C21.5707 31.4603 19.2271 29.8406 18.3713 27.4879C18.2332 27.1075 17.8713 26.8529 17.4541 26.9664C17.086 27.0676 16.7946 27.5001 16.9326 27.8836C18.0277 30.8928 20.8621 32.9142 24.0768 32.8866C27.267 32.859 30.0707 30.6811 31.0553 27.6842C31.3559 26.767 29.9173 26.3774 29.6167 27.2885",
				fill: "#1C1C1C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.9203 28.7426C12.9203 30.0861 11.4571 31.1751 9.65033 31.1751C7.84358 31.1751 6.37732 30.0861 6.37732 28.7426C6.37732 27.399 7.84358 26.3101 9.65033 26.3101C11.4571 26.3101 12.9203 27.399 12.9203 28.7426Z",
				fill: "#FF2180"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M41.6196 28.7426C41.6196 30.0861 40.1564 31.1751 38.3497 31.1751C36.5429 31.1751 35.0767 30.0861 35.0767 28.7426C35.0767 27.399 36.5429 26.3101 38.3497 26.3101C40.1564 26.3101 41.6196 27.399 41.6196 28.7426Z",
				fill: "#FF2180"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5302_91261",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			fill: "white"
		})
	}) })]
});
export default SvgEmojiBlueSmileEyeOpen;
